import { inject, Injectable, signal } from '@angular/core';
import { Jobopslag } from '@features/letpensiondk/letpensiondk-jobopslag/jobopslag.model';
import { JobopslagDatasource } from '@features/letpensiondk/letpensiondk-jobopslag/jobopslag.datasource';

@Injectable({
  providedIn: 'root'
})
export class JobopslagService  {
  datasource = inject(JobopslagDatasource);
  selectedJobopslag = signal<Jobopslag | undefined>(undefined);
  activeTab = signal('list');
  mode = signal('update');
  searchText = signal('');
  medtagSlettede = signal(false);


  selectJobopslag(jobopslag: Jobopslag) {
    this.mode.set('update');
    this.selectedJobopslag.set(jobopslag);

    if (jobopslag) {
      this.activeTab.set('detail');
    }
  }

  opretJobopslag() {
    this.mode.set('create');
    this.selectedJobopslag.set(undefined);
    this.activeTab.set('detail');
  }

  onSearch() {
    this.datasource.searchParams.set({
      text: this.searchText(),
      medtagSlettede: this.medtagSlettede()
    });
  }

}
